import { axiosClient } from '../../library/Service/axiosClient';

const base = () => `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/stories`;

export function formContext(narratorId: string, instituteId: string | number, protagonistId?: string) {
    const params = new URLSearchParams({ narratorId, instituteId: String(instituteId) });
    if (protagonistId) params.set('protagonistId', protagonistId);
    return axiosClient().get(`${base()}/form-context?${params.toString()}`);
}

export function alumniSearch(instituteId: string | number, q: string, passoutYear?: string, protagonistId?: string) {
    const params = new URLSearchParams({ instituteId: String(instituteId), q: q || '' });
    if (passoutYear) params.set('passoutYear', passoutYear);
    if (protagonistId) params.set('protagonistId', protagonistId);
    return axiosClient().get(`${base()}/alumni-search?${params.toString()}`);
}

export function create(body: Record<string, unknown>) {
    return axiosClient().post(`${base()}/`, body);
}

export function update(id: string | number, body: Record<string, unknown>) {
    return axiosClient().put(`${base()}/${id}`, body);
}

export function get(id: string | number) {
    return axiosClient().get(`${base()}/${id}`);
}

export function forAlumni(userId: string) {
    return axiosClient().get(`${base()}/for-alumni/${userId}`);
}

export function search(body: Record<string, unknown>) {
    return axiosClient().post(`${base()}/search`, body);
}

export function remove(id: string | number) {
    return axiosClient().post(`${base()}/${id}/delete`);
}
